import React from "react";
import { connect } from "react-redux";
import radarIcon from './searching.png';
import portConnected from './Icon_Connect.svg';
import "./coding-area.css";
import pictoBloxIcon from './PictoBlox.ico';
import iconDisconnect from './Icon_Disconnect.svg';
import evivePeripheralImage from './icon-evive-illustration.svg';
import arduinoMegaPeripheralImage from './icon-arduino-mega-illustration.svg';
import arduinoUnoPeripheralImage from './icon-arduino-uno-illustration.svg';
import arduinoNanoPeripheralImage from './icon-arduino-nano-illustration.svg';
import esp32PeripheralImage from './icon-esp32-illustration.svg';
import TWatchPeripheralImage from './icon-ttgo-illustration.svg';
import QuarkyPeripheralImage from './icon-quarky-illustration.svg';
import TecBitsPeripheralImage from './tecBits.png';
import BoffinPeripheralImage from './boffin.svg';
import microBitPeripheralImage from "./microbit-illustration.svg";
class CodingArea extends React.Component{

    constructor(props){
        super(props);
    }
    componentDidMount(){
        
    }
    render(){
        return (
            <div style={{display:"flex",flexGrow:"2",alignItems:"center",justifyContent:"center", height:"100%"}}>
               {this.props.isPictoBloxConnected?(<div style={{width:"100%"}}><div style={{textAlign:"center"}}>Connection established !!</div>
                {
                    this.props.currentSelectedBoard == "None"?(null):(
                        <div style={{marginTop:"2%"}}>
                            <img 
                                src = {pictoBloxIcon}
                                width = "8%"
                            />
                            {this.props.isBluetoothPortConnected?<img src={portConnected} style={{paddingBottom:"2%"}} width = "3%" />:<img src={iconDisconnect} style={{paddingBottom:"2%"}} width = "3%" color="black"/>}
                            {this.props.currentSelectedBoard == "Quarky"?<img src={QuarkyPeripheralImage} width = "5%"/>:
                             this.props.currentSelectedBoard == "evive"?<img style={{paddingBottom:"1%"}} src={evivePeripheralImage} width = "5%"/>:
                            this.props.currentSelectedBoard == "T-Watch"?<img style={{paddingBottom:"0.5%"}} src={TWatchPeripheralImage} width = "6%"/>:
                            this.props.currentSelectedBoard == "ESP32"?<img style={{paddingBottom:"0.5%"}} src={esp32PeripheralImage} width = "5%"/>:
                            this.props.currentSelectedBoard == "micro:bit"?<img style={{paddingBottom:"1%"}} src={microBitPeripheralImage} width = "6%"/>:
                            this.props.currentSelectedBoard == "Arduino Nano"?<img style={{paddingBottom:"2%"}} src={arduinoNanoPeripheralImage} width = "8%"/>:
                            this.props.currentSelectedBoard == "Arduino Mega"?<img style={{paddingBottom:"2%"}} src={arduinoMegaPeripheralImage} width = "8%"/>:
                            this.props.currentSelectedBoard == "Arduino Uno"?<img style={{paddingBottom:"2%"}} src={arduinoUnoPeripheralImage} width = "6%"/>:
                            this.props.currentSelectedBoard == "Boffin"?<img src={BoffinPeripheralImage} width = "5%"/>:
                            this.props.currentSelectedBoard == "TecBits"?<img src={TecBitsPeripheralImage} width = "7%"/>:
                            <p style={{color:"red"}}>Currently, bluetooth functionality is not supported for this board in chromebook.</p>
                        }
                        </div>
                        )
                        //connection Symbol
                        
                    
                }
                </div>):(<div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
                    <img
                        src={radarIcon}
                        className="radar-big radar-spin"
                    />
                    <div>Waiting for connection from PictoBlox Software...</div>
                </div>)}
                {/* <div style={{float:"left"}}>
                    Current Selected Board : {this.props.currentSelectedBoard}
                </div> */}
            </div>
        )
    }
} 
const mapStateToProps = (state) =>{
    return {
        isPictoBloxConnected: state.codingAreaReducer.isConnectedWithPictoBlox,
        currentSelectedBoard: state.codingAreaReducer.currentSelectedBoard,
        isBluetoothPortConnected: state.menuBarReducer.isBoardConnected,
    }
}
export default connect(mapStateToProps)(CodingArea);